import { StandardModal, Button, BodyText, Flex } from '@bamboohr/fabric';

interface ContactCancelModalProps {
    isOpen: boolean;
	onClose: () => void;
}

export function ContactCancelModal({ isOpen, onClose, }: ContactCancelModalProps): JSX.Element {
	return (
		<StandardModal
			isOpen={isOpen}
			onRequestClose={onClose}
		>
			<StandardModal.Body
				renderFooter={
					<StandardModal.Footer
						actions={[
							<Button
                                data-bi-id="billing-contact-us-cancel-modal-close"
								key="got-it-button"
								onClick={onClose}
								type="button"
								variant="contained"
							>
								{$.__('Got It')}
							</Button>,
						]}
					/>
				}
				renderHeader={<StandardModal.Header title={$.__('Cancel BambooHR Account')} />}
			>
				<StandardModal.Constraint>
					<StandardModal.HeroHeadline
						icon="phone-regular"
						subtext={<BodyText weight="medium">{$.__('7 AM and 5 PM MT Monday - Friday')}</BodyText>}
						text="1-833-598-0776"
					/>
                    <Flex marginTop={1} marginX={2} textAlign="center">
                        <BodyText>
                            {$.__("We're here to help. Give us a call and we'll walk you through the cancellation process, including scheduling your cancellation date and making sure your account data is handled properly.")}
                        </BodyText>
                    </Flex>
				</StandardModal.Constraint>
			</StandardModal.Body>
		</StandardModal>
	);
}
